module.exports = __webpack_public_path__ + "media/images/icons/expander_round_down-40c72f0313abc27b2e7b4636710daea7.svg";